import { SvgIconProps } from '@mui/material';

import {
  AviIcon,
  CsvIcon,
  DocIcon,
  GenericIcon,
  GenericSetIcon,
  GifIcon,
  IsoIcon,
  JpgIcon,
  LinkIcon,
  MovIcon,
  Mp3Icon,
  Mp4Icon,
  PdfIcon,
  PngIcon,
  SVGIcon,
  TxtIcon,
  XlxIcon,
  ZipIcon,
} from 'src/components/icons';

const fileExtensionToIcon: Record<
  string,
  (props: SvgIconProps) => JSX.Element
> = {
  avi: AviIcon,
  doc: DocIcon,
  docx: DocIcon,
  generic: GenericIcon,
  genericSet: GenericSetIcon,
  iso: IsoIcon,
  jpg: JpgIcon,
  jpeg: JpgIcon,
  mov: MovIcon,
  mp3: Mp3Icon,
  mpeg: Mp3Icon,
  pdf: PdfIcon,
  png: PngIcon,
  txt: TxtIcon,
  zip: ZipIcon,
  svg: SVGIcon,
  link: LinkIcon,
  mp4: Mp4Icon,
  gif: GifIcon,
  csv: CsvIcon,
  xlx: XlxIcon,
  xlsx: XlxIcon,
  xls: XlxIcon,
};

const isExtString = (
  extension: string,
): extension is KeyOf<typeof fileExtensionToIcon> => {
  return !!fileExtensionToIcon[extension];
};

export const getFileIconComponent = (
  extension: string,
): ((props: SvgIconProps) => JSX.Element) => {
  const ext = extension.toLowerCase();
  if (isExtString(ext)) {
    return fileExtensionToIcon[ext] || GenericIcon;
  }
  return GenericIcon;
};

export const useFileIcon = () => {
  const getIcon = (extension: string) => {
    const ext = extension.toLocaleLowerCase();
    if (!isExtString(ext)) {
      return <GenericIcon style={{ fontSize: 27, fill: 'none' }} />;
    }
    const Icon = fileExtensionToIcon[ext] || fileExtensionToIcon.generic;
    return <Icon style={{ fontSize: 27, fill: 'none' }} />;
  };

  return { getIcon };
};
